import {defaultTransformFn, dsApi} from "./DsApi";
import {AudienceSegment} from "../entities/AudienceSegment";
import {BillboardGeo} from "../entities/BillboardGeo";

const toolsTags = dsApi.enhanceEndpoints({
    addTagTypes: ["InternetSegments", "TvSegments"],
});

const toolsApi = toolsTags.injectEndpoints({
    endpoints: (build) => ({
        getInternetSegments: build.query<AudienceSegment[], { query: string }>({
            query: ({query}) => {
                return {
                    url: `tools/audienceSegments/internet?query=${query}`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: (resp, _, req) => [{type: "InternetSegments", id: req.query}],
        }),
        getTvSegments: build.query<AudienceSegment[], { query: string }>({
            query: ({query}) => {
                return {
                    url: `tools/audienceSegments/tv?query=${query}`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: (resp, _, req) => [{type: "TvSegments", id: req.query}],
        }),
        getBillboardGeos: build.query<BillboardGeo[], { lat: number, lng: number, radiusMeters: number}>({
            query: (request) => {
                return {
                    url: `tools/billboardGeos`,
                    method: "POST",
                    data: {
                        lat: request.lat,
                        lng: request.lng,
                        radiusMeters: request.radiusMeters,
                    }
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: () => [],
        }),
    }),
})

export const {
    useGetInternetSegmentsQuery,
    useGetTvSegmentsQuery,
    useGetBillboardGeosQuery,
} = toolsApi;